<template>
  <slot></slot>
</template>

<script>
import { defineComponent } from 'vue'
import 'driver.js/dist/driver.css'
import { driver } from 'driver.js'
import Storage from '@/shared/utils/storage'

export default defineComponent({
  name: 'TourGuide',
  components: {},
  props: {},
  data() {
    return {
      guideWindowLeft: 0,
      guideWindowTop: 0,
      guideWindowWidth: 0,
      guideWindowHeight: 0,
      guidIsVisible: false,
      guideText: '',
      tourGuideTextPositionX: 'center',
      eventsIds: [],
    }
  },
  setup() {},
  mounted() {
    window.requireTourGuid = this.onTourGuidRequired
  },
  methods: {
    onTourGuidRequired(...args) {
      this.makeTourGuidV2(...args)
    },
    async makeTourGuidV2({
      el = '',
      title = '',
      description = '',
      id = '',
      maxRepeat = 1,
      delay = 0,
      hideOnBotomSheet = true,
      allowClose = true,
      steps = [],
      onDone = () => {},
      willStart = async () => {},
    }) {
      if (delay && typeof delay == 'number') {
        await new Promise(r => setTimeout(r, delay))
      }

      if (hideOnBotomSheet) {
        const bottomsheetVisible = document.querySelector('.bottomsheetContent')
        if (bottomsheetVisible) return
      }

      let nbFinished = Storage.get(`nbFinishedGuid-${id}`)
      if (!nbFinished) nbFinished = 0
      if (maxRepeat && nbFinished >= maxRepeat) return

      if (typeof willStart == 'function') await willStart()

      this.finishGuid = () => {
        if (typeof onDone == 'function') onDone()
        this.guidIsVisible = false
        if (id) {
          nbFinished++
          Storage.save(`nbFinishedGuid-${id}`, nbFinished)
        }
        this.finishGuid = () => {}
      }

      const baseConfig = {
        nextBtnText: 'Suivant',
        prevBtnText: 'Précédent',
        doneBtnText: 'Terminer',
        popoverClass: 'driverjs-theme',
        allowClose,
      }
      if (title) {
        const driverObj = driver()
        driverObj.highlight({
          ...baseConfig,
          element: el,
          popover: {
            title,
            description,
          },
          onDeselected: () => {
            this.finishGuid()
            driverObj.moveNext()
          },
        })
      } else if (Array.isArray(steps) && steps.length > 0) {
        const stepsConfig = steps.map((step, i) => {
          return {
            element: step.el,
            popover: { title: step.title, description: step.description },
            onDone: async () => {
              if (step.onDone && typeof step.onDone == 'function') {
                await step.onDone()
              }
              if (steps[i + 1] && steps[i + 1].earlyScrollIntoView) {
                const element = document.querySelector(steps[i + 1].el)
                element.scrollIntoView()
                await new Promise(r => setTimeout(r, 500))
              }
              if (steps[i + 1] && steps[i + 1].preventScrollIntoView) {
                const element = document.querySelector(steps[i + 1].el)
                element.scrollIntoViewCopy = element.scrollIntoView
                element.scrollIntoView = function () {}
                // setTimeout(() => {
                //   element.scrollIntoView = element.scrollIntoViewCopy
                //   element.scrollIntoViewCopy = null
                // }, 500)
              }
            },
            onPrev: step.onPrev,
          }
        })
        console.log(stepsConfig)
        const driverObj = driver({
          ...baseConfig,
          steps: stepsConfig,
          onNextClick: async (el, step) => {
            // console.log(step)
            if (step.onDone && typeof step.onDone == 'function') {
              await step.onDone()
            }
            driverObj.moveNext()
          },
          onPrevClick: async (el, step) => {
            // console.log(step)
            if (step.onPrev && typeof step.onPrev == 'function') {
              await step.onPrev()
            }
            driverObj.movePrevious()
          },
          onDestroyed: () => {
            this.finishGuid()
            console.log('destroyed')
          },
        })
        driverObj.drive()
      }
    },
    finishGuid() {},
  },
  watch: {},
})
</script>

<style>
.driver-popover.driverjs-theme {
  background-color: var(--colors-primary-300);
  color: #1c1c1c;
}

.driver-popover.driverjs-theme .driver-popover-title {
  font-size: 1.3rem;
  padding-right: 1rem;
}

.driver-popover.driverjs-theme .driver-popover-title,
.driver-popover.driverjs-theme .driver-popover-description,
.driver-popover.driverjs-theme .driver-popover-progress-text {
  color: #1c1c1c;
}

.driver-popover.driverjs-theme button {
  flex: 1;
  text-align: center;
  background-color: #1c1c1c;
  color: #ffffff;
  border: 2px solid #1c1c1c;
  text-shadow: none;
  font-size: 0.8rem;
  padding: 0.5rem 0.2rem;
  border-radius: 6px;
}

.driver-popover.driverjs-theme button:hover {
  background-color: #1c1c1c;
  color: #ffffff;
}

.driver-popover.driverjs-theme .driver-popover-navigation-btns {
  justify-content: space-between;
  gap: 3px;
}

.driver-popover.driverjs-theme .driver-popover-close-btn {
  /* color: #9b9b9b; */
  right: 0.5rem;
  top: 0.5rem;
  width: 2rem;
  height: 2rem;
  padding: 0rem !important;
}

.driver-popover.driverjs-theme .driver-popover-close-btn:hover {
  color: #1c1c1c;
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-left.driver-popover-arrow {
  border-left-color: var(--colors-primary-300);
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-right.driver-popover-arrow {
  border-right-color: var(--colors-primary-300);
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-top.driver-popover-arrow {
  border-top-color: var(--colors-primary-300);
}

.driver-popover.driverjs-theme
  .driver-popover-arrow-side-bottom.driver-popover-arrow {
  border-bottom-color: var(--colors-primary-300);
}
</style>
